import React from 'react';
import { useEkomiWidgetScript } from '@Theme/natucare/hooks/useEkomiWidget';
import './EkomiWidget.scss';
import * as styles from './EkomiWidget.module.scss';
const EkomiWidget = () => {
  useEkomiWidgetScript();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: "ekomi-widget-sf1529446596c4ce725f4"
  }));
};
export default EkomiWidget;